export enum UserType {
  Guest,
  Client,
  Admin,
}
